import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const LikeChatChallenges1 = lazyWithPreload(
  () => import('./LikeChatChallenges1'),
)
export const LikeChatChallenges2 = lazyWithPreload(
  () => import('./LikeChatChallenges2'),
)
